// Deck type constants
var STANDARD = 0;
var EUCHRE = 1;
var PINOCHLE = 2;

var cards = (function() {
  // Table position constants (rotation in degrees)
  var TABLE_BOTTOM = 0;
  var TABLE_TOP = 180;
  var TABLE_LEFT = 90;
  var TABLE_RIGHT = -90;

  //The global options
  var opt = {
    cardSize: {
      width: 69,
      height: 94,
      padding: 18
    },
    animationSpeed: 500,
    table: 'body',
    cardback: 'red',
    acesHigh: false,
    cardsUrl: 'img/cards.png',
    blackJoker: false,
    redJoker: false,
    type: STANDARD,
    loop: 1
  };
  var zIndexCounter = 1;
  var all = []; //All the cards created.
  var start = 1;
  var end = start + 12;

  function mouseEvent(ev) {
    var card = $(this).data('card');
    if (card.container) {
      var handler = card.container._click;
      if (handler) {
        handler.func.call(handler.context || window, card, ev);
      }
    }
  }

  function init(options) {
    // Reset: clear existing cards before creating new ones
    // This allows multiple independent instances (e.g., multi-player dev view)
    for (var i = 0; i < all.length; i++) {
      if (all[i].el) {
        $(all[i].el).remove();
      }
    }
    all.length = 0;

    if (options) {
      for (var i in options) {
        if (opt.hasOwnProperty(i)) {
          opt[i] = options[i];
        }
      }
    }
    switch (opt.type) {
      case STANDARD:
        opt.acesHigh = false;
        start = opt.acesHigh ? 2 : 1;
        end = start + 12;
        break;
      case EUCHRE:
        start = 9;
        end = start + 5;
        break;
      case PINOCHLE:
        start = 9;
        end = start + 5;
        opt.loop = 2;
        break;
    }

    opt.table = $(opt.table)[0];
    if ($(opt.table).css('position') == 'static') {
      $(opt.table).css('position', 'relative');
    }
    for (let l = 0; l < opt.loop; l++)
      for (var i = start; i <= end; i++) {
        all.push(new Card('h', i, opt.table));
        all.push(new Card('s', i, opt.table));
        all.push(new Card('d', i, opt.table));
        all.push(new Card('c', i, opt.table));
      }
    if (opt.blackJoker) {
      all.push(new Card('bj', 0, opt.table));
    }
    if (opt.redJoker) {
      all.push(new Card('rj', 0, opt.table));
    }

    $('.card').click(mouseEvent);
    shuffle(all);
  }

  function shuffle(deck) {
    //Fisher yates shuffle
    var i = deck.length;
    if (i == 0) return;
    while (--i) {
      var j = Math.floor(Math.random() * (i + 1));
      var tempi = deck[i];
      var tempj = deck[j];
      deck[i] = tempj;
      deck[j] = tempi;
    }
  }

  function Card(suit, rank, table) {
    this.init(suit, rank, table);
  }

  Card.prototype = {
    init: function(suit, rank, table) {
      this.shortName = suit + rank;
      this.suit = suit;
      this.rank = rank;
      this.name = suit.toUpperCase() + rank;
      this.faceUp = false;
      this.rotation = 0;           // Current rotation angle in degrees
      this.sourceRotation = null;  // Source rotation for animation (set when moving between containers)
      this.el = $('<div/>').css({
        width: opt.cardSize.width,
        height: opt.cardSize.height,
        "background-image": 'url(' + opt.cardsUrl + ')',
        position: 'absolute',
        cursor: 'pointer'
      }).addClass('card').data('card', this).appendTo($(table));
      this.showCard();
      this.moveToFront();
    },

    toString: function() {
      return this.name;
    },

    moveTo: function(x, y, speed, callback) {
      var props = {
        top: y - (opt.cardSize.height / 2),
        left: x - (opt.cardSize.width / 2)
      };
      $(this.el).animate(props, speed || opt.animationSpeed, callback);
    },

    rotate: function(angle) {
      $(this.el)
        .css('-webkit-transform', 'rotate(' + angle + 'deg)')
        .css('-moz-transform', 'rotate(' + angle + 'deg)')
        .css('-ms-transform', 'rotate(' + angle + 'deg)')
        .css('transform', 'rotate(' + angle + 'deg)')
        .css('-o-transform', 'rotate(' + angle + 'deg)');
    },

    showCard: function() {
      var offsets = {
        "c": 0,
        "d": 1,
        "h": 2,
        "s": 3,
        "rj": 2,
        "bj": 3
      };
      var xpos, ypos;
      var rank = this.rank;
      if (rank == 14) {
        rank = 1; //Aces high must work as well.
      }
      xpos = -rank * opt.cardSize.width;
      ypos = -offsets[this.suit] * opt.cardSize.height;
      // Note: rotation is now preserved (not reset to 0)
      $(this.el).css('background-position', xpos + 'px ' + ypos + 'px');
      this.faceUp = true;
    },

    hideCard: function(position) {
      var y = opt.cardback == 'red' ? 0 * opt.cardSize.height : -1 * opt.cardSize.height;
      $(this.el).css('background-position', '0px ' + y + 'px');
      // Note: rotation is now preserved (not reset to 0)
      this.faceUp = false;
    },

    moveToFront: function() {
      $(this.el).css('z-index', zIndexCounter++);
    },

    highlight: function() {
      $(this.el).addClass('highlighted');
      return this;
    },

    unhighlight: function() {
      $(this.el).removeClass('highlighted');
      return this;
    },

    select: function() {
      $(this.el).addClass('selected');
      return this;
    },

    unselect: function() {
      $(this.el).removeClass('selected');
      return this;
    }
  };

  function Container() {

  }

  Container.prototype = new Array();
  Container.prototype.extend = function(obj) {
    for (var prop in obj) {
      this[prop] = obj[prop];
    }
  }
  Container.prototype.extend({
    addCard: function(card) {
      this.addCards([card]);
    },

    addCards: function(cards) {
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        // Capture source rotation before removing from old container
        if (card.container) {
          card.sourceRotation = card.container.rotation || 0;
          card.container.removeCard(card);
        } else {
          card.sourceRotation = card.rotation || 0;
        }
        this.push(card);
        card.container = this;
      }
    },

    removeCard: function(card) {
      for (var i = 0; i < this.length; i++) {
        if (this[i] == card) {
          this.splice(i, 1);
          card.container = null;
          return true;
        }
      }
      return false;
    },

    init: function(options) {
      options = options || {};
      this.x = options.x || $(opt.table).width() / 2;
      this.y = options.y || $(opt.table).height() / 2;
      this.faceUp = options.faceUp;
      this.rotation = options.rotation || 0;  // Container rotation in degrees
    },

    click: function(func, context) {
      this._click = {
        func: func,
        context: context
      };
    },

    mousedown: function(func, context) {
      this._mousedown = {
        func: func,
        context: context
      };
    },

    mouseup: function(func, context) {
      this._mouseup = {
        func: func,
        context: context
      };
    },

    render: function(options) {
      options = options || {};
      var speed = options.speed || opt.animationSpeed;
      var targetRotation = this.rotation || 0;

      this.calcPosition(options);

      for (var i = 0; i < this.length; i++) {
        var card = this[i];
        zIndexCounter++;
        card.moveToFront();

        var top = parseInt($(card.el).css('top'));
        var left = parseInt($(card.el).css('left'));
        var needsMove = (top != card.targetTop || left != card.targetLeft);

        // Determine if rotation animation is needed
        var sourceRot = card.sourceRotation !== null ? card.sourceRotation : card.rotation;
        var needsRotation = (sourceRot !== targetRotation);

        // If rotation changed and card has a source rotation, set it immediately first
        // This ensures animation starts from the correct position
        if (needsRotation && card.sourceRotation !== null && !options.immediate) {
          card.rotate(sourceRot);
        }

        if (needsMove || needsRotation) {
          var props = {
            top: card.targetTop,
            left: card.targetLeft,
            queue: false
          };

          if (options.immediate) {
            $(card.el).css(props);
            card.rotate(targetRotation);
          } else {
            $(card.el).animate(props, speed);
            // Apply target rotation - CSS transition handles the animation
            // Use a small delay to ensure source rotation is applied first
            if (needsRotation) {
              (function(c, rot) {
                setTimeout(function() { c.rotate(rot); }, 10);
              })(card, targetRotation);
            }
          }
        }

        // Update card's rotation state and clear source
        card.rotation = targetRotation;
        card.sourceRotation = null;
      }

      var me = this;
      var flip = function() {
        for (var i = 0; i < me.length; i++) {
          if (me.faceUp) {
            me[i].showCard();
          } else {
            me[i].hideCard();
          }
        }
      }
      if (options.immediate) {
        flip();
      } else {
        setTimeout(flip, speed / 2);
      }

      if (options.callback) {
        setTimeout(options.callback, speed);
      }
    },

    topCard: function() {
      return this[this.length - 1];
    },

    toString: function() {
      return 'Container';
    },

    highlight: function() {
      for (var i = 0; i < this.length; i++) {
        this[i].highlight();
      }
      // Show placeholder highlight if container is empty
      if (this.length === 0 && this._placeholder) {
        $(this._placeholder).addClass('highlighted');
      }
      return this;
    },

    unhighlight: function() {
      for (var i = 0; i < this.length; i++) {
        this[i].unhighlight();
      }
      if (this._placeholder) {
        $(this._placeholder).removeClass('highlighted');
      }
      return this;
    },

    createPlaceholder: function(tableSelector) {
      if (this._placeholder) return this;

      var table = tableSelector || opt.table;
      this._placeholder = $('<div class="card-placeholder"></div>')
        .css({
          position: 'absolute',
          width: opt.cardSize.width + 'px',
          height: opt.cardSize.height + 'px',
          left: (this.x - opt.cardSize.width / 2) + 'px',
          top: (this.y - opt.cardSize.height / 2) + 'px',
          border: '2px dashed rgba(255, 255, 255, 0.3)',
          borderRadius: '5px',
          boxSizing: 'border-box',
          pointerEvents: 'auto',
          cursor: 'pointer',
          display: 'none',
          zIndex: 50
        })
        .appendTo($(table));

      // Forward clicks to container click handler
      var me = this;
      this._placeholder.click(function(ev) {
        if (me._click) {
          me._click.func.call(me._click.context || window, null, ev);
        }
      });

      return this;
    },

    updatePlaceholder: function() {
      if (!this._placeholder) return this;
      if (this.length === 0) {
        $(this._placeholder).show();
      } else {
        $(this._placeholder).hide();
      }
      return this;
    },

    setRotation: function(angle) {
      this.rotation = angle;
      if (this._placeholder) {
        this.setPlaceholderRotation(angle);
      }
      return this;
    },

    setPlaceholderRotation: function(angle) {
      if (!this._placeholder) return this;
      $(this._placeholder)
        .css('-webkit-transform', 'rotate(' + angle + 'deg)')
        .css('-moz-transform', 'rotate(' + angle + 'deg)')
        .css('-ms-transform', 'rotate(' + angle + 'deg)')
        .css('transform', 'rotate(' + angle + 'deg)')
        .css('-o-transform', 'rotate(' + angle + 'deg)');
      return this;
    }
  });

  function Deck(options) {
    this.init(options);
  }

  Deck.prototype = new Container();
  Deck.prototype.extend({
    calcPosition: function(options) {
      options = options || {};
      var left = Math.round(this.x - opt.cardSize.width / 2, 0);
      var top = Math.round(this.y - opt.cardSize.height / 2, 0);
      var condenseCount = 6;
      for (var i = 0; i < this.length; i++) {
        if (i > 0 && i % condenseCount == 0) {
          top -= 1;
          left -= 1;
        }
        this[i].targetTop = top;
        this[i].targetLeft = left;
      }
    },

    toString: function() {
      return 'Deck';
    },

    deal: function(count, hands, speed, callback) {
      var me = this;
      var i = 0;
      var totalCount = count * hands.length;

      function dealOne() {
        if (me.length == 0 || i == totalCount) {
          if (callback) {
            callback();
          }
          return;
        }
        hands[i % hands.length].addCard(me.topCard());
        hands[i % hands.length].render({
          callback: dealOne,
          speed: speed
        });
        i++;
      }
      dealOne();
    }
  });

  function Hand(options) {
    this.init(options);
  }
  Hand.prototype = new Container();
  Hand.prototype.extend({
    calcPosition: function(options) {
      options = options || {};
      var rotation = this.rotation || 0;
      var isVertical = (Math.abs(rotation) === 90);

      if (isVertical) {
        // Vertical fan layout for left/right players
        var height = opt.cardSize.height + (this.length - 1) * opt.cardSize.padding;
        var top = Math.round(this.y - height / 2);
        var left = Math.round(this.x - opt.cardSize.width / 2);

        // Left player (90°): fan downward, first card at top
        // Right player (-90°): fan upward, last card at top
        var isLeft = rotation > 0;

        for (var i = 0; i < this.length; i++) {
          var posIndex = isLeft ? i : (this.length - 1 - i);
          this[i].targetTop = top + posIndex * opt.cardSize.padding;
          this[i].targetLeft = left;
        }
      } else {
        // Horizontal fan layout (original logic)
        var width = opt.cardSize.width + (this.length - 1) * opt.cardSize.padding;
        var left = Math.round(this.x - width / 2);
        var top = Math.round(this.y - opt.cardSize.height / 2, 0);
        for (var i = 0; i < this.length; i++) {
          this[i].targetTop = top;
          // Use forward indexing so position order matches z-index order:
          // Index 0 = leftmost (lowest z-index), Index N-1 = rightmost (highest z-index, fully visible)
          this[i].targetLeft = left + i * opt.cardSize.padding;
        }
      }
    },

    toString: function() {
      return 'Hand';
    }
  });

  function Pile(options) {
    this.init(options);
  }

  Pile.prototype = new Container();
  Pile.prototype.extend({
    calcPosition: function(options) {
      options = options || {};
    },

    toString: function() {
      return 'Pile';
    },

    deal: function(count, hands) {
      if (!this.dealCounter) {
        this.dealCounter = count * hands.length;
      }
    }
  });


  return {
    init: init,
    all: all,
    options: opt,
    SIZE: opt.cardSize,
    Card: Card,
    Container: Container,
    Deck: Deck,
    Hand: Hand,
    Pile: Pile,
    shuffle: shuffle,
    // Table position constants
    TABLE_BOTTOM: TABLE_BOTTOM,
    TABLE_TOP: TABLE_TOP,
    TABLE_LEFT: TABLE_LEFT,
    TABLE_RIGHT: TABLE_RIGHT
  };
})();

if (typeof module !== 'undefined') {
  module.exports = cards;
}
